<template>
  <div class="app-main-content" type="primary">
    <cabin-list
      v-show="view==='list'"
      ref="cabinList"
      :context="context"
      @look="lookHandle"
      @edit="editHandle"
      @clone="cloneHandle"
      @add="addHandle"
    />
    <cabin-detail
      v-show="view==='detail'"
      ref="cabinDetail"
      :context="context"
      @edit="editHandle"
      @add="addHandle"
      @clone="cloneHandle"
      @back="backToList"
    />

    <!--    复制弹框-->
    <copy-window
      v-if="copyWindow.visible"
      ref="copyWindow"
      :visible.sync="copyWindow.visible"
      :source="copyWindow.source"
      @copy="copyHandler"
    />
  </div>
</template>
<script>

import CabinList from '@/views/cargo/v0/SeaExport/cabinManagement/cabinList.vue'
import { BookingNewContext } from '@/views/cargo/v0/SeaExport/bookingNewContext'
import CabinDetail from '@/views/cargo/v0/SeaExport/cabinManagement/cabinDetail.vue'
import CopyWindow from '@/views/cargo/v0/SeaExport/cabinManagement/copyWindow.vue'
import { doCopyCabinFunc } from '@/api/booking/cabinManagement'

export default {
  name: 'CabinManagement',
  components: { CopyWindow, CabinDetail, CabinList },
  data() {
    return {
      view: 'list',
      context: BookingNewContext.getInstance(),
      isAdvancedQuery: false, // 是否为高级查询
      templateName: null,
      filterJson: {},
      copyWindow: {
        source: {},
        visible: false
      },
      selectData: null
    }
  },
  computed: {},
  activated() {
    const params = this.$route.params
    if (params.jobNos) {
      const { jobNos, jobNo, activeTabName, editState } = params
      if (activeTabName === 'list') {
        this.view = 'list'
        this.$refs.cabinList.toDiractQuery(jobNos)
      }
      delete params.jobNos
      delete params.jobNo
      delete params.activeTabName
      delete params.editState
    }
  },
  methods: {
    lookHandle(row) {
      this.view = 'detail'
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.view = 'detail'
      this.detailHandle('edit', row)
    },
    /**
     * 新增或者复制
     * options 用于复制
     * @param options
     */
    addHandle(options) {
      this.view = 'detail'
      this.detailHandle('add', options ? options.data : null, options)
    },
    cloneHandle(data) {
      this.copyWindow.source = data
      this.copyWindow.visible = true
    },
    detailHandle(type, row, options) {
      this.$refs.cabinDetail.onShow(type, row, options)
    },
    copyHandler(event) {
      const { data, copyNum, listType, fillType, note } = event
      const copyData = {
        uuid: data.uuid,
        copyNum: copyNum,
        listType: listType,
        fillType: fillType,
        note: note
      }
      doCopyCabinFunc(copyData).then(res => {
        copyData.data = res.data
        this.addHandle(copyData)
      })
    },
    backToList() {
      this.view = 'list'
      this.$refs.cabinList.toQuery()
    }
  }
}
</script>
